import slugify from 'slugify'

export default () => {
  const createSlug = (item: string) => slugify(item, { lower: true, remove: /[/*+~.,()'"!:@]/g })

  return { slugify: createSlug }
}
